import { render, staticRenderFns } from "./ContractCustomerDetails.vue?vue&type=template&id=4559d7f1&scoped=true&"
import script from "./ContractCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./ContractCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractCustomerDetails.vue?vue&type=style&index=0&id=4559d7f1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4559d7f1",
  null
  
)

export default component.exports